import React from 'react';
import { useModalDismiss } from '../../hooks/useModalDismiss';

interface GlobalConfirmModalProps {
  show: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export function GlobalConfirmModal({ 
  show, 
  title, 
  message, 
  confirmText = "确定", 
  cancelText = "取消", 
  onConfirm, 
  onCancel 
}: GlobalConfirmModalProps) {
  const dismiss = useModalDismiss(onCancel);
  if (!show) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'var(--modal-mask)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000
    }} {...dismiss}>
      <div style={{
        backgroundColor: 'var(--card-bg)', padding: '24px', borderRadius: 12, width: 320,
        boxShadow: '0 10px 25px var(--shadow-color)', color: 'var(--text-color)'
      }}>
        <h3 style={{ marginBottom: 12, fontSize: 18, fontWeight: 600 }}>{title}</h3>
        <p style={{ color: 'var(--text-secondary)', marginBottom: 24, fontSize: 14, lineHeight: 1.5 }}>{message}</p>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
          {cancelText && (
            <button 
              onClick={onCancel} 
              data-testid="global-confirm-cancel"
              style={{ padding: '8px 16px', border: '1px solid var(--border-color)', backgroundColor: 'transparent', color: 'var(--text-secondary)', borderRadius: 6, cursor: 'pointer', fontSize: 13 }}
            >
              {cancelText}
            </button>
          )}
          <button 
            onClick={onConfirm} 
            data-testid="global-confirm-ok"
            style={{ padding: '8px 16px', backgroundColor: 'var(--danger-color)', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 13, fontWeight: 500 }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
